import React, { useEffect, useState } from "react";
import { Checkbox, Search, Table } from "@veneer/core";
import { Container, Row, Col } from "react-bootstrap";
import Exporttoexcel from "./exporttoexcel";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OnPageLoad_POST } from "../../../../services";
import { apiPost } from "../../../../services/service";
import { toast } from "react-toastify";
import Loader from "../../shared-components/loader/loader";
import Favourite from "./favourite";
import { useAppDispatch } from "@store/hooks";
import { setLoading } from "@store/reducers/loadingSlice";
import { escape } from "querystring";
import { AdminNotIndividualRole, ExportMaping, newToOladSorting } from "utils";

const sortedColumns = [
  "hpi_caseid",
  "hpi_name",
  "hpi_orderstatus",
  "hpi_partnumber",
  "hpi_partdescription",
  "hpi_serialnumber",
  "hpi_partnumber_po",
  "hpi_trackingnumber",
  "hpi_removedserialnumber",
  "createdon",
  "hpi_expecteddeliverydate",
  "customerid",
  "favourite",
];

const MyOrders = ({ tabledata }: any) => {
  const [order, setOrder] = useState(sortedColumns);
  const [orderBy, setOrderBy] = useState("hpi_caseid");
  const [orderType, setOrderType] = useState("ascending");
  const [exportXlRow, setExportXlRow] = useState<any>([]);
  const [isChecked, setIsChecked] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [recentCase, setRecentCase] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const [value, setValue] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [progress, setProgress] = useState<boolean>(false);
  const pageSize = 30;
  const pagination = [{}];
  const dispatch = useAppDispatch();
  const handleUpdate = () => {
    setIsChecked(false);
  };
  const setTableFliterData = (recentPartOrders: any) => {
    let updatedcases = recentPartOrders.map((incident: any) => ({
      ...incident,
      hpi_caseid: resBtn(incident),
      favourite: (
        <>
          <Favourite
            caseId={incident.incidentid}
            favourite={incident.favourite}
            pageload={fetchTableData}
            tableid={"favourite_cases"}
            loader={addloader}
            setIsChecked={handleUpdate}
          />
        </>
      ),
    }));
    setRecentCase(updatedcases);
  };

  const handleSearch = (value: string | undefined, field: string) => {
    if (!value) {
      setTableFliterData(pageLoad);
      return;
    }
    let filtered: any;
    if (field === "favourite") {
      filtered = pageLoad.filter((item: any) => {
        return item?.[field]?.toLowerCase()?.includes(value);
      });
    } else {
      setIsChecked(false);
      filtered = pageLoad.filter((item: any) => {
        return item?.[field]
          ?.toLowerCase()
          ?.includes(value.trim().toLowerCase());
      });
    }
    setTableFliterData(filtered);
  };

  const handleOnlyFevList = (e: any) => {
    setIsChecked(e.target.checked);
    handleSearch(e.target.checked, "favourite");
  };
   const baseTableColumn = [
    {
      id: "hpi_caseid",
      label: t('HPI.MainHomePage.grids.CaseId',{defaultValue:'Case Id'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_caseid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_name",
      label: t('HPI.MainHomePage.partorder.PartsAndOrder',{defaultValue:'Parts and order'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_name")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_orderstatus",
      label: t('HPI.MainHomePage.partorder.Orderstatus',{defaultValue:'Order status'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_orderstatus")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_partnumber",
      label: t('HPI.MainHomePage.partorder.PartNumber',{defaultValue:'Part number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_partnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_partdescription",
      label: t('HPI.MainHomePage.partorder.PartDescription',{defaultValue:'Part description'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_partdescription")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_serialnumber",
      label: t('HPI.ucProductInfo.pgSerialNum',{defaultValue:'Serial number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_serialnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_partnumber_po",
      label:  t('HPI.ucProductInfo.pgProductNum',{defaultValue:'Product number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_partnumber_po")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_trackingnumber",
      label: t('HPI.MainHomePage.partorder.Trackingnumber',{defaultValue:'Tracking Number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_trackingnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_removedserialnumber",
      label: t('HPI.MainHomePage.partorder.ReplacementSerialnumber',{defaultValue:'Replacement Serial Number'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_removedserialnumber")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "createdon",
      label: t('HPI.MainHomePage.serviceorder.CreatedOn',{defaultValue:'Created Date'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "createdon")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "hpi_expecteddeliverydate",
      label: t('HPI.MainHomePage.partorder.ExpecteddeliveryDate',{defaultValue:'Expected Delivery date'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_expecteddeliverydate")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },
    {
      id: "customerid",
      label: t('HPI.MainHomePage.grids.AccountName',{defaultValue:'Site-account'}),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "customerid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    } ];

  const favouriteColumn = [{
      id: "favourite",
      label: t('HPP.MainHomePage.FavoriteHeadertext',{defaultValue:'Favorite'}),
      filter: (
        <Checkbox
          id="checkbox"
          checked={isChecked}
          label={t("HPI.ShowMyFavouriteCW", {
            defaultValue: "Show Favorites Only",
          })}
          onChange={(e: any) => handleOnlyFevList(e)}
        />
      ),
    },
  ];

  const columns= AdminNotIndividualRole ? [...baseTableColumn,
      // Check if the user is not an individual and has admin role
      {
        id: "hpi_bulkid",
        label: t("HPI.MainHomePage.ByCompanyTab.BulkId", {
          defaultValue: "Bulk Id",
        }),
      filter: (
        <Search
          placeholder={t("HPI.ContractWarranties.btnSearch", {
            defaultValue: "Search",
          })}
          id="table-filter-Name"
          onChange={(v) => handleSearch(v, "hpi_bulkid")}
          onClear={() => setTableFliterData(pageLoad)}
        />
      ),
    },...favouriteColumn] : [...baseTableColumn,...favouriteColumn];
  const resBtn = (data: any) => {
    let uri = `cid=${data.incidentid}`;
    return (
      <button
        className="link"
        onClick={() => {
          navigate(`/edit-case?${uri}`, { state: { data } });
        }}
      >
        {data.hpi_caseid}
      </button>
    );
  };
  const addloader = () => {
    dispatch(setLoading(true));
  };
  const fetchTableData = async () => {
    dispatch(setLoading(true));
    const payload = {
      contactid: "85680c15-7814-e711-80fc-5065f38ad971",
      accountid: "f16eeb64-73fc-e611-80fa-5065f38ad971",
      tabid: "Recentcasepartorders",
      submittedbyme: false,


    };

    try {
      const res = await apiPost(OnPageLoad_POST, payload);
      if (res.data) {
        const orderlist = JSON.parse(res.data.RecentPartOrders)
        const sortedOrder = newToOladSorting(orderlist, 'createdon');
        const recentPartOrders = sortedOrder;
        let fieldMap =  {
          "Case ID": "hpi_caseid",
          "Parts and order": "hpi_name",
          "Order status": "hpi_orderstatus",
          "Part number": "hpi_partnumber",
          "Part description": "hpi_partdescription",
          "Serial Number": "hpi_serialnumber",
          "Product Number": "hpi_partnumber_po",
          "Tracking Number": "hpi_trackingnumber",
          "Replacement Serial Number": "hpi_removedserialnumber",
          "Created Date": "createdon",
          "Expected Delivery date": "hpi_expecteddeliverydate",
          "Site-account": "customerid",
           };

        let exporteddata = ExportMaping(fieldMap, recentPartOrders);
        setExportXlRow(exporteddata);
        setPageLoad(recentPartOrders);
        setTableFliterData(recentPartOrders);
        dispatch(setLoading(false));
        setIsLoading(false);
      } else {
        setIsLoading(false);
        dispatch(setLoading(false));
        toast.error(res.Message);
      }
    } catch (error) {
      setIsLoading(false);
      dispatch(setLoading(false));
      console.error(error);
    } finally {
      setIsLoading(false);
      dispatch(setLoading(false));
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  useEffect(() => {
    if (!pagination) setCurrentPage(1);
  }, [pagination]);

  const handleSort = (_: any, { id, type }: any) => {
    setOrderBy(id);
    setOrderType(type);
  };

  let pagedData = recentCase?.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );
  if (pagedData.length === 0) {
    pagedData = recentCase;
  }
  const paginationProps = {
    currentPage,
    pageSize,
    onPageChange: (page: number) => setCurrentPage(page),
    totalItems: recentCase?.length,
  };

  return (
    <>

      <div className="d-flex justify-content-end mb-4 mt-4"><Exporttoexcel fileName="My Orders" rows={exportXlRow} /></div>
      <Table
        columns={columns}
        loading={isLoading}
        data={pagedData}
        pagination={paginationProps}
        showFilters
      />
    </>
  );
};

export default MyOrders;
